import { Button, TableCell, TableRow } from '@mui/material'
import React, { useState } from 'react'
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import EditDialog from './EditUserDialog';
import ConfirmDialog from '../../components/Modals/ConfirmDialog';
import { Store } from 'react-notifications-component';
import { useDeleteUserMutation, useUpdateUserMutation } from '../../features/fullApi';
import { toast } from 'react-hot-toast';
import { tableCellClasses } from '@mui/material/TableCell';
import { styled } from '@mui/material/styles';
import { Navigate, useNavigate } from 'react-router-dom';

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));


const User = ({userData}) => {

    console.log("USER IS", userData)
    const [open, setOpen] = useState(false)
    const [openEdit, setOpenEdit] = useState(false)
    const user = JSON.parse(localStorage.getItem('user'))

    const navigate = useNavigate()



    const openModalEditItem = (() => {
        setOpenEdit(true)
      })

      const editItemMessage = "You are updating this item"
  
      const [updateUser] = useUpdateUserMutation()
      const [deleteUser] = useDeleteUserMutation()
    
      const message = "Are you sure you want to delete this user ?";
    
      const openDeleteModal = (() => {
        setOpen(true)
      })
    
      const handleUpdateUser = ((user) => {
        console.log("USER SENT IS", user)
        setOpenEdit(false)
        updateUser({_id: user.id, username: user.username, email: user.email}, { 
          headers: {
            'Token': `Bearer ${user?.accessToken}`
          }
        }).then(
          toast.success("User edited successfully")
        )
      })
    
    
      const handleDelete = (async (userId) => {  
        deleteUser({id: userId})
        setOpen(false)
      })

  return (
    <>
        {user?.isAdmin && (
          <StyledTableRow sx={{width:'300px'}}>
                <StyledTableCell sx={{paddingRight:'0px'}}>{userData.username.length > 10 ? userData.username.substring(0, 10) + "..." : userData.username}</StyledTableCell>
                <StyledTableCell sx={{paddingRight:'0px'}}>
                <Button aria-label="Edit Item" size="small" color="secondary" variant="contained" onClick={() => navigate(`/orders/find/${userData._id}`)}>orders</Button>
                </StyledTableCell>
                <StyledTableCell sx={{paddingRight:'0px'}}>
                <Button aria-label="Edit Item" onClick={() => openModalEditItem(userData._id)}>
                  <EditIcon style={{color: 'orange'}}/>
                </Button>
                </StyledTableCell>
                <StyledTableCell sx={{paddingRight:'0px'}}>
                <Button aria-label="Delete product" onClick={() => openDeleteModal(userData._id)} size="small">
                  <DeleteIcon style={{color: 'red'}}/>
                </Button>
                </StyledTableCell>
          </StyledTableRow>
        )}
      <EditDialog openEdit={openEdit} handleUpdateUser={handleUpdateUser} setOpenEdit={setOpenEdit} item={userData} message={editItemMessage}>         
      </EditDialog>
      <ConfirmDialog open={open} handleDelete={handleDelete} setOpen={setOpen} item={userData} message={message}></ConfirmDialog>
  </>
  )
}

export default User